export class MessageModel {
    message: string;
    status: string;
    title: string;
    timeOutId: number;
    isShow: boolean = false;
}
